const containerCls = "_n29c2d9ya2";
const canvasCls = "_n29c1cqaljm";

export { canvasCls, containerCls };
import "./LegacyCanvasDrawing.style.linaria.module.css";
//# sourceMappingURL=LegacyCanvasDrawing.style.js.map
